import { Injectable } from '@angular/core';
import { ConfigClient, FeatureManagement } from './api.service';
import { BehaviorSubject, Observable, filter, map, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FeatureManagementService {
  private featureSubject = new BehaviorSubject<FeatureManagement | undefined>(undefined);
  private featuresLoadedSubject = new BehaviorSubject<boolean>(false);
  featuresLoaded$ = this.featuresLoadedSubject.asObservable();

  constructor(configClient: ConfigClient) {
    configClient.featureConfig().subscribe((featureState) => {
      this.featureSubject.next(featureState);
      this.featuresLoadedSubject.next(true);
    });
  }

  get features(): Observable<FeatureManagement> {
    return this.featureSubject.pipe(filter((features) => !!features)) as Observable<FeatureManagement>;
  }

  isFeatureEnabled(featureName: keyof FeatureManagement): Observable<boolean> {
    return this.featureSubject.pipe(
      filter((config) => !!config),
      map((config) => config![featureName] as boolean),
      shareReplay(1),
    );
  }
}
